export enum CartLoaderType {
  NORMAL = 'NORMAL',
  GCO = 'GCO',
  PAGE_LOADER = 'CIRCLE_LOADER',
}
